import api from '@/api'

export default {
  fetch (contractId, recommendedRisk, query, tag, limit, page, isin) {
    return api.get('/investments', {
      params: {
        contract_id: contractId,
        query,
        tag,
        limit,
        page,
        isin,
        sort: recommendedRisk ? `wesave_notes.${recommendedRisk}` : null
      }
    })
  },
  fetchByIsin (isin) {
    return api.get(`/investments/${isin}`)
  },
  fetchTags () {
    return api.get('/tags')
  }
}
